import type { BdState } from '../../de/state/state.model';

export const AT_STATES: BdState[] = [
  { id: 1, name: 'Burgenland' },
  { id: 2, name: 'Kärnten' },
  { id: 3, name: 'Niederösterreich' },
  { id: 4, name: 'Oberösterreich' },
  { id: 5, name: 'Salzburg' },
  { id: 6, name: 'Steiermark' },
  { id: 7, name: 'Tirol' },
  { id: 8, name: 'Vorarlberg' },
  { id: 9, name: 'Wien' },
];

export class AtStateStore {
  public static byId(stateId: number): BdState | null {
    const result = AT_STATES.filter((state) => state.id === stateId);
    return result[0] ? result[0] : null;
  }
}
